import {
  Mesh,
  PerspectiveCamera,
  Scene,
  WebGLRenderer,
} from 'three';
import XJSJScene from './xjsj-scene';
import texManager from './tex-manager';
export default class RendererController {
  renderer: WebGLRenderer;
  scene: Scene;
  camera: PerspectiveCamera;
  cube!: Mesh;
  xjsjScene: XJSJScene;

  constructor(canvas: HTMLCanvasElement, wrapper?: HTMLDivElement) {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    this.scene = new Scene();
    this.camera = new PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    this.renderer = new WebGLRenderer({
      canvas,
      antialias: true,
    });
    this.renderer.setPixelRatio(
      window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio
    );
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(this.renderer.domElement);

    texManager.init(this.renderer);

    // 创建一个立方体
    // const geometry = new BoxGeometry();
    // const material = new MeshBasicMaterial({ color: 0x00ff00 });
    // this.cube = new Mesh(geometry, material);
    // this.scene.add(this.cube);

    // 设置相机位置
    // this.camera.position.z = 5;

    wrapper?.prepend(this.renderer.domElement);

    // glb
    this.xjsjScene = new XJSJScene(this.renderer, this);
  }
  anim(time: number, delta: number) {
    this.xjsjScene.anim(time, delta);
  }
  dispose() {
    this.xjsjScene.dispose();
  }
}
